import React from "react";
import DashboardLayout from "../../components/DashboardLayout";
import { Link } from "react-router-dom";
import { FLEETRIFYROUTEPATH } from "../../routes/routesPath";
import FleetrifyCard from "../../components/Card";
import CompanyBranchesTable from "../../components/Table/CompanyBranchesTable";
import FleetrifyFilter from "../../components/Filter/filter";
import useCompanyBranchesControllers from "../../controllers/useCompanyBranchesControllers";
import { planOption, statusOption } from "../../utils/mock";
import DeactivateCompanyBranchModal from "../../components/pages/CompanyBranches/DeactivateModal";

const CompanyBranches = () => {
  const {
    filter,
    showDeactivateModal,
    handleFilterChange,
    handleDeactive,
    setShowDeactivateModal,
    handleSuspend,
  } = useCompanyBranchesControllers();
  const { search, status, planType } = filter;
  return (
    <>
      <DashboardLayout
        title={
          <div>
            <div className="flex gap-1 items-center">
              <Link to={FLEETRIFYROUTEPATH.COMPANY} className="text-sm">
                Company
              </Link>
              <span>{">"}</span>
              <Link to={FLEETRIFYROUTEPATH.COMPANY_DETAILS} className="text-sm">
                Company Details
              </Link>
              <span>{">"}</span>
              <p>Company Branches</p>
            </div>
          </div>
        }
        containerClass="space-y-10"
      >
        <FleetrifyCard cardContainerClass="!min-h-fit">
          <div className="flex justify-between bg-[#F5F6FA] p-5 rounded-lg">
            <div className="flex items-center space-x-5">
              <div className="w-20 h-20 relative rounded-full bg-[#14388733] flex items-center justify-center text-[28px] font-bold text-[#143887]">
                <p>HL</p>
              </div>
              <div className="space-y-2">
                <p className="text-[20px] text-[#143887] font-bold">
                  Hassan Enterpise
                </p>
                <p className="text-xs text-[#00032A]">User ID: #53767</p>
              </div>
            </div>
          </div>
          <CompanyBranchesTable
            renderLeftContent={
              <FleetrifyFilter
                searchWrapClass="!border bg-transparent rounded-[30px]"
                selectWrapClass="!border bg-transparent"
                searchValue={search}
                onSearchChange={(value) => handleFilterChange("search", value)}
                statusOption={statusOption}
                onStatusChange={(value: any) =>
                  handleFilterChange("status", value)
                }
                statusValue={status}
                planOption={planOption}
                onPlanChange={(value: any) =>
                  handleFilterChange("planType", value)
                }
                planvalue={planType}
                locationOption={[]}
                onLocationChange={(value: any) =>
                  handleFilterChange("location", value)
                }
              />
            }
            actionMenu={(row) => [
              {
                label: "Deactive",
                func: () => handleDeactive(row),
              },
              {
                label: "Suspend",
                func: () => handleSuspend(row),
              },
            ]}
          />
        </FleetrifyCard>
      </DashboardLayout>
      <DeactivateCompanyBranchModal
        isModalOpen={showDeactivateModal}
        setIsModalOpen={setShowDeactivateModal}
      />
    </>
  );
};

export default CompanyBranches;
